export default __webpack_public_path__ + "static/media/hamdy-osama-b.5b393600.jpg";